/** Admin dashboard nav items — permission key gates visibility */
export const ADMIN_NAV_ITEMS = [
  {
    permission: 'users.add',
    label: 'Add new user',
    description: 'Create student or staff accounts',
    path: '/admin/add-user',
    group: 'People',
  },
  {
    permission: 'users.add',
    label: 'VE onboarding',
    description: 'Internal VLSI Expert onboarding form (VE team only)',
    path: '/admin/onboarding',
    group: 'People',
  },
  {
    permission: 'users.edit',
    label: 'Edit user',
    description: 'Update profiles and enrollments',
    path: '/admin/edit-user',
    group: 'People',
  },
  {
    permission: 'users.requests.review',
    label: 'Account requests',
    description: 'Approve VE team onboarding requests and create logins',
    path: '/admin/creation-requests',
    group: 'People',
  },
  {
    permission: 'students.filter',
    label: 'Filter students',
    description: 'Search and review student records',
    path: '/admin/filter-students',
    group: 'People',
  },
  {
    permission: 'students.filter',
    label: 'Student profile completeness',
    description: 'Find students with missing details and track complete profiles',
    path: '/admin/student-profile-completeness',
    group: 'People',
  },
  {
    permission: 'students.manage',
    label: 'Manage students',
    description: 'Bulk actions and student lifecycle',
    path: '/admin/student-management',
    group: 'People',
  },
  {
    permission: 'import.ve',
    label: 'Import VE Excel',
    description: 'Import the official multi-sheet workbook',
    path: '/admin/ve-import',
    group: 'Import',
  },
  {
    permission: 'import.pma',
    label: 'Lab Linux users',
    description: 'Create lab Linux accounts; see host capacity and suggested placement',
    path: '/admin/pma-student-import',
    group: 'Import',
  },
  {
    permission: 'import.pma',
    label: 'Lab user cycle',
    description: 'Live lab users, policy warnings, disable, enable, and delete',
    path: '/admin/lab-cycle',
    group: 'Import',
  },
  {
    permission: 'import.pma',
    label: 'Server accounts',
    description: 'Login, VNC, storage, and whether to keep or remove each lab account',
    path: '/admin/lab-fleet',
    group: 'Import',
  },
  {
    permission: 'capacity.plan',
    label: 'Server capacity',
    description: 'Historical capacity and how many more accounts each server can take',
    path: '/admin/server-capacity',
    group: 'Import',
  },
  {
    permission: 'import.ve',
    label: 'Data staging review',
    description: 'Resolve incomplete or ambiguous staged rows after rules run',
    path: '/admin/data-staging-review',
    group: 'Import',
  },
  {
    permission: 'batches',
    label: 'Batch management',
    description: 'Batches, schedules, and status',
    path: '/admin/batches',
    group: 'Training',
  },
  {
    permission: 'batches.assign_trainers',
    label: 'Assign batch trainers',
    description: 'Link or unlink trainers to batches',
    path: '/admin/batches?trainers=1',
    group: 'Training',
  },
  {
    permission: 'course_categories',
    label: 'Course categories',
    description: 'Organize course catalogue',
    path: '/admin/course-categories',
    group: 'Training',
  },
  {
    permission: 'courses',
    label: 'Courses',
    description: 'Course definitions and links',
    path: '/admin/courses',
    group: 'Training',
  },
  {
    permission: 'modules',
    label: 'Modules',
    description: 'Training modules and progress',
    path: '/admin/modules',
    group: 'Training',
  },
  {
    permission: 'interview_readiness',
    label: 'Interview readiness',
    description: 'Readiness gates and ratings',
    path: '/admin/interview-readiness',
    group: 'Training',
  },
  {
    permission: 'module_progress',
    label: 'Module completion',
    description: 'Report and update module Completed / Ongoing',
    path: '/admin/module-completion',
    group: 'Training',
  },
  {
    permission: 'mock_interviews',
    label: 'Mock interviews',
    description: 'Mock interview tracking',
    path: '/admin/mock-interviews',
    group: 'Training',
  },
  {
    permission: 'training_concerns',
    label: 'Training concerns',
    description: 'Fees, tools, and delivery issues',
    path: '/admin/training-concerns',
    group: 'Training',
  },
  {
    permission: 'counselling',
    label: 'Counselling sessions',
    description: 'Counsellor notes and follow-ups',
    path: '/admin/counselling',
    group: 'Training',
  },
  {
    permission: 'placements',
    label: 'Placements',
    description: 'Opportunities and placed students',
    path: '/admin/placements',
    group: 'Placement',
  },
  {
    permission: 'reporting',
    label: 'Reporting dashboard',
    description: 'Operational reports and metrics',
    path: '/admin/reporting',
    group: 'Insights',
  },
  {
    permission: 'masters',
    label: 'Master data',
    description: 'Reference lists and dropdowns',
    path: '/admin/masters',
    group: 'System',
  },
  {
    permission: 'masters',
    label: 'Training centers',
    description: 'Add and edit Location of Center',
    path: '/admin/training-centers',
    group: 'Catalog',
  },
  {
    permission: 'notifications.send',
    label: 'Notifications',
    description: 'Compose and send email / in-app messages',
    path: '/admin/notifications',
    group: 'Communications',
  },
  {
    permission: 'feature_flags.manage',
    label: 'Feature flags',
    description: 'Turn product features and notification events on or off',
    path: '/admin/feature-flags',
    group: 'System',
  },
  {
    permission: 'access.manage',
    label: 'Access management',
    description: 'Roles, levels, and special access',
    path: '/admin/access-management',
    group: 'System',
  },
  {
    permission: 'system.backup',
    label: 'Database backups',
    description: 'Upload or snapshot up to five restore points and roll back',
    path: '/admin/database-backups',
    group: 'System',
  },
];

export const NAV_GROUP_ORDER = [
  'People',
  'Import',
  'Training',
  'Placement',
  'Communications',
  'Insights',
  'System',
];

export function isPrivilegedStaffRole(role) {
  return role === 'admin' || role === 'superadmin';
}

/** Nav keys that only a superadmin receives. The capacity API also checks the superadmin role. */
export const SUPERADMIN_ONLY_PERMISSIONS = ['import.pma', 'capacity.plan'];

export function getUserPermissions(user) {
  if (!user) return [];
  const role = user.role || user.user?.role;
  const fromRoot = user.permissions;
  const fromNested = user.user?.permissions;
  const stored = Array.isArray(fromRoot)
    ? fromRoot
    : Array.isArray(fromNested)
      ? fromNested
      : [];

  if (role === 'superadmin' || role === 'admin') {
    const auto = ADMIN_NAV_ITEMS.map((i) => i.permission).filter(
      (p) => role === 'superadmin' || !SUPERADMIN_ONLY_PERMISSIONS.includes(p)
    );
    return [...new Set([...stored, ...auto])];
  }

  return stored;
}

export function hasPermission(user, permissionKey) {
  if (!permissionKey) return true;
  return getUserPermissions(user).includes(permissionKey);
}

export function filterNavItemsForUser(user) {
  return ADMIN_NAV_ITEMS.filter((item) => hasPermission(user, item.permission));
}

export function groupNavItems(items) {
  const byGroup = new Map();
  for (const item of items) {
    const group = item.group || 'Other';
    if (!byGroup.has(group)) byGroup.set(group, []);
    byGroup.get(group).push(item);
  }
  return NAV_GROUP_ORDER.filter((g) => byGroup.has(g)).map((group) => ({
    group,
    items: byGroup.get(group),
  }));
}
